import { DotPatternCfg } from '../../types/pattern';
import { deepAssign } from '../../utils';
import {
  getUnitPatternSize,
  initCanvas,
  drawBackground,
  getSymbolsPosition,
  transformMatrix,
  getPixelRatio,
} from './util';

/**
 * dotPatternçé»è®¤éç½®
 */
export const defaultDotPatternCfg = {
  size: 6,
  padding: 2,
  backgroundColor: 'transparent',
  opacity: 1,
  rotation: 0,
  fill: '#fff',
  fillOpacity: 0.5,
  stroke: 'transparent',
  lineWidth: 0,
  isStagger: true,
};

/**
 * ç»å¶åç¹
 *
 * @param context
 * @param cfg
 * @param x åç¹ä¸­å¿åæ x
 * @param y åç¹ä¸­å¿åæ y
 */
export function drawDot(context: CanvasRenderingContext2D, cfg: DotPatternCfg, x: number, y: number) {
  const { size, fill, lineWidth, stroke, fillOpacity } = cfg;

  context.beginPath();
  context.globalAlpha = fillOpacity;
  context.fillStyle = fill;
  context.strokeStyle = stroke;
  context.lineWidth = lineWidth;
  context.arc(x, y, size / 2, 0, 2 * Math.PI, false);
  context.fill();
  if (lineWidth) {
    context.stroke();
  }
  context.closePath();
}

/**
 * åå»º dot patternï¼è¿å HTMLCanvasElement
 *
 * @param cfg
 * @returns HTMLCanvasElement
 */
export function createDotPattern(cfg?: DotPatternCfg): CanvasPattern {
  const dotCfg = deepAssign({}, defaultDotPatternCfg, cfg);

  const { size, padding, isStagger, rotation } = dotCfg;

  // è®¡ç® ç»å¸å¤§å°ï¼dotsçä½ç½®
  const unitSize = getUnitPatternSize(size, padding, isStagger);
  const dots = getSymbolsPosition(unitSize, isStagger);

  // åå§å patternCanvas
  const canvas = initCanvas(unitSize, unitSize);
  const ctx = canvas.getContext('2d');

  // ç»å¶ backgroundï¼dots
  drawBackground(ctx, dotCfg, unitSize);
  for (const [x, y] of dots) {
    drawDot(ctx, dotCfg, x, y);
  }

  const pattern = ctx.createPattern(canvas, 'repeat');

  if (pattern) {
    const dpr = getPixelRatio();
    const matrix = transformMatrix(dpr, rotation);
    pattern.setTransform(matrix);
  }

  return pattern;
}
